export default __webpack_public_path__ + "static/media/image3.005e035e.jpg";